export default {"src":"/_next/static/media/boost_64.2a4697c3.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};